import styled from "@emotion/styled";
import MenuItem, { menuItemClasses } from "@mui/base/MenuItem";
import { fontRoboto } from "@product/scmp-sdk";

import { Card } from "~/components/common/card";

export const ListboxStyled = styled(Card)`
  padding: 4px;
`;

export const MenuItemStyled = styled(MenuItem)`
  padding: 8px;

  color: #666666;
  font-size: 14px;
  font-family: ${fontRoboto};

  list-style: none;

  cursor: default;

  user-select: none;

  &:hover:not(.${menuItemClasses.disabled}) {
    color: #000000;
  }

  &.${menuItemClasses.focusVisible} {
    color: #2c4692;

    outline: 0;
  }
`;
